module.exports = __webpack_public_path__ + "static/media/20ECE24.22a4037a.jpg";